<template>
  <bs-modal ref="media-modal" modal-class="media-modal fix-modal"
            size="lg" content-class="shadow" @hidden="emitClose">
    <template v-slot:modal-header>
      <h5 class="modal-title">
        Media Library
      </h5>
    </template>
    <template v-slot:default>
      <media-library-content v-on:selected="onSelected"></media-library-content>
    </template>
    <template v-slot:modal-footer>
      <bs-button class="btn-info" :disabled="!selectedFile" @click="confirm">Select</bs-button>
    </template>
  </bs-modal>
</template>
<script>
import Vue from 'vue';
import { BModal, BButton } from 'bootstrap-vue';
import MediaLibraryContent from './MediaLibraryContent.vue';

export default {
  components: {
    'bs-modal': BModal,
    'bs-button': BButton,
    'media-library-content': MediaLibraryContent,
  },
  props: {
    open: Boolean,
  },
  watch: {
    open(val) {
      if (val) {
        this.$refs['media-modal'].show();
      } else {
        Vue.nextTick(() => {
          this.$refs['media-modal'].hide();
        });
      }
    },
  },
  data() {
    return {
      selectedFile: null,
    };
  },
  mounted() {
  },
  methods: {
    onSelected(data) {
      this.selectedFile = data;
    },
    confirm() {
      this.$emit('onSelect', this.selectedFile);
    },
    emitClose() {
      this.$emit('onClose');
    },
  },
};
</script>
<style lang="scss">
  .media-modal {
    .modal-header {
      padding: 1.25rem;
    }
    .modal-body {
      padding: 0;
    }
    .modal-title {
      font-size: 17px;
      color: #333;
      font-weight: bold;
    }
    .modal-body {
      padding: 0;
    }
    .modal-footer {
      padding: 0.8rem 1.25rem;
    }
  }
</style>
